import { render, staticRenderFns } from "./HeaderSidebarV2.vue?vue&type=template&id=3ec92bf9&scoped=true"
import script from "./HeaderSidebarV2.vue?vue&type=script&lang=js"
export * from "./HeaderSidebarV2.vue?vue&type=script&lang=js"
import style0 from "./HeaderSidebarV2.vue?vue&type=style&index=0&id=3ec92bf9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec92bf9",
  null
  
)

export default component.exports